import { Check, checkFactory } from './check';
import { Station } from './station.class';
import { User } from './user.class';
import { Picture } from './picture.interface'

import { groupBy } from 'lodash';

export class Maintenance {
  public id?: string;
  public state: string;
  public date?: Date;
  public numDAT?: string;
  public equipementsDescription?: string;
  public pictures: Array<Picture>;
  public checks: Array<Check>;
  public Station?: Station;
  public StationId?: string;
  public By?: User;
  public ById?: string;
  public previous?: Maintenance;

  constructor(obj?: any) {
    let data = {
      state: 'created',
      pictures: [],
      checks: [],
      ...(obj || {})
    };

    this.id = data.id;
    this.state = data.state;
    this.date = new Date(data.date);
    this.numDAT = data.numDAT;
    this.equipementsDescription = data.equipementsDescription;
    this.pictures = data.pictures ? data.pictures.map((picture) => {
      if(typeof picture === 'string') return {id: picture };
      else return picture;
    }) : [];
    this.checks = data.checks.map((check) => checkFactory(check));
    if (data.Station) this.Station = new Station(data.Station);
    this.StationId = data.StationId;
    if (data.By) this.By = new User(data.By);
    this.ById = data.ById;
    if (data.previous) this.previous = new Maintenance(data.previous);
  }

  addCheck(type: string) {
    let check = checkFactory({
      type: type,
    });
    this.checks.push(check);
    return check;
  }

  removeCheck(check: Check) {
    let idx = this.checks.indexOf(check);
    if(idx >= 0) {
      this.checks.splice(idx, 1);
      return true;
    }
    return false;
  }

  public groupChecksByType(): {[key: string]: Check[]} {
    return groupBy(this.checks, 'type');
  }

  toJSON() {
    return {
      id: this.id,
      state: this.state,
      date: this.date,
      numDAT: this.numDAT,
      equipementsDescription: this.equipementsDescription,
      pictures: this.pictures,
      checks: this.checks,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/maintenance.class.ts